import { render, staticRenderFns } from "./Info2Slider.vue?vue&type=template&id=0819bb38&scoped=true&"
import script from "./Info2Slider.vue?vue&type=script&lang=js&"
export * from "./Info2Slider.vue?vue&type=script&lang=js&"
import style0 from "./Info2Slider.vue?vue&type=style&index=0&id=0819bb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0819bb38",
  null
  
)

export default component.exports